<div class="advanced-search-inner">
  <div class="form-group bigdiv location-auto-complete" [ngClass]="{'nosavesearchbtn' : !canShowsavedSearch}">

    <mat-form-field class="mat-no-border select-highlight mobile-change-select matautocomplete">
      <input matInput
             placeholder="Search Tenants"
             [matAutocomplete]="auto"
             [(ngModel)]="searchCriteria.TenantAddressInput"
             (input)="dataServiceInput$.next($event.target.value);" />

      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onPropertySelect($event.option.value)">

        <ng-container *ngIf="dataService$ | async as items">
          <ng-container *ngIf="items.length > 0; else noResults">
            <mat-option class="split-location" *ngFor="let item of items; trackBy: trackByIndex"
                        [value]="item">
              <div class="split-container">
                <span>{{ item.PropertyName }}</span>
                <span class="location-type">{{ item.Type }}</span>
              </div>
            </mat-option>
          </ng-container>
        </ng-container>
        <ng-template #noResults>
          <mat-option disabled>
            No data available
          </mat-option>
        </ng-template>
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div [class]="IsNull(searchCriteria.AssetTypes).length==0? 'form-group smalldiv' :'form-group smalldiv selected-div'">
    <div class="select-dropdown right-border multiselectdesign">
      <mat-form-field class="mat-no-border select-highlight mobile-change-select property-type-form">
        <mat-label>Property Types</mat-label>
        <mat-select panelClass="dynamic-width" id="mySelect" class="propertylisting-search" multiple>
          <div (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()" class="search-wrapper search-property-type">
            <mat-form-field class="no-bottom-border">
              <input matInput
                     placeholder="Search Property Types"
                     class="search-input" [(ngModel)]="searchPropertyType" (keyup)="onSearchChange()" />
            </mat-form-field>

          </div>
          <mat-optgroup *ngFor="let group of inputAssetTypes">
            <div>
              <mat-checkbox (click)="$event.stopPropagation()" [checked]="group.checked" (change)="toggleParent($event, group);" class="blue-checkbox">
                {{group.itemName}}
              </mat-checkbox>
              <span (click)="expandTypes(group)" class="btn-collapse" [class.span-open]="isExpandCategory[group.id]" *ngIf="group?.subCategory!=null&&group?.subCategory?.length>0">
                <i class="fa fa-angle-down" aria-hidden="true" *ngIf="!isExpandCategory[group.id]"></i>
                <i class="fa fa-angle-up" aria-hidden="true" *ngIf="isExpandCategory[group.id]"></i>
              </span>
            </div>

            <mat-option *ngFor="let name of group?.subCategory" class="hide-mat-option child-option" [ngClass]="{'show':isExpandCategory[group.id],'list-hide':!isExpandCategory[group.id]}">
              <div class="child-row">
                <mat-checkbox (click)="$event.stopPropagation()"
                              [checked]="name?.checked"
                              (change)="togglechild($event, name)" class="blue-checkbox">
                  {{name?.name}}
                </mat-checkbox>
              </div>
            </mat-option>
          </mat-optgroup>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div [class]="IsNull(searchCriteria.PriceFrom)+IsNull(searchCriteria.PriceTo) =='' ? 'form-group smalldiv pricediv clearfix' :'form-group smalldiv pricediv clearfix'">
    <div class="btn-group select-dropdown clearfix right-border" dropdown (click)="dropdown.hide()">
      <button dropdownToggle type="button" class="btn btn-default dropdown-toggle " area-expanded="true">
        Price <span class="caret"></span>
      </button>
      <div *dropdownMenu class="dropdown-menu dropdown-div" (click)="$event.stopPropagation()">
        <div class="form-group margin0">
          <div class="row">
            <div class="resp-col">
              <div class="textbox-with-btn-left">
                <input inputmode="numeric" (keydown)="onInputKeyPress($event)" maxlength="15" type="text" class="search-field-input form-control" mask="separator.10" thousandSeparator="," (keyup)="buildTags($event,2)" [(ngModel)]="searchCriteria.PriceFrom" placeholder="- Min -" value="{{searchCriteria.PriceFrom|number}}">
                <span class="leftlabel">$</span>
              </div>
              <span class="minusspan">-</span>
            </div>

            <div class="resp-col">
              <div class="textbox-with-btn-left">
                <input inputmode="numeric" (keydown)="onInputKeyPress($event)" maxlength="15" type="text" class="search-field-input form-control" mask="separator.10" thousandSeparator="," (keyup)="buildTags($event,2)" [(ngModel)]="searchCriteria.PriceTo" placeholder="- Max -" value="{{searchCriteria.PriceTo|number}}">
                <span class="leftlabel">$</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [class]="IsNull(searchCriteria.CapRateFrom)+IsNull(searchCriteria.CapRateTo) =='' ? 'form-group smalldiv pricediv clearfix' :'form-group smalldiv pricediv clearfix'">
    <div class="btn-group select-dropdown clearfix right-border" dropdown>
      <button dropdownToggle type="button" class="btn btn-default dropdown-toggle " area-expanded="true">
        Cap Rate <span class="caret"></span>
      </button>
      <div *dropdownMenu class="dropdown-menu dropdown-div rowlayout" (click)="$event.stopPropagation()">
        <div class="form-group margin0">
          <div class="row">
            <div class="resp-col margin-bottom-15">
              <div class="textbox-with-4character textbox-with-2character textbox-with-btn">
                <input inputmode="decimal" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control" [dropSpecialCharacters]="false" mask="999.99" (keyup)="buildTags($event,11)" [(ngModel)]="searchCriteria.CapRateFrom" placeholder="- Min -" (change)="validateFilters()">
                <span class="rightlabel">%</span>
              </div>
            </div>
            <div class="resp-col">
              <div class="textbox-with-4character  textbox-with-2character textbox-with-btn">
                <input inputmode="decimal" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control" [dropSpecialCharacters]="false" mask="999.99" (keyup)="buildTags($event,11)" [(ngModel)]="searchCriteria.CapRateTo" placeholder="- Max -" (change)="validateFilters()">
                <span class="rightlabel">%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div [class]="IsNull(searchCriteria.MinTerm)+IsNull(searchCriteria.MaxTerm) =='' ? 'form-group smalldiv pricediv clearfix' :'form-group smalldiv pricediv clearfix'">
    <div class="btn-group select-dropdown clearfix right-border" dropdown (click)="dropdown.hide()">
      <button dropdownToggle type="button" class="btn btn-default dropdown-toggle " area-expanded="true">
        Term <span class="caret"></span>
      </button>
      <div *dropdownMenu class="dropdown-menu dropdown-div rowlayout" (click)="$event.stopPropagation()">
        <div class="form-group margin0">
          <div class="row">
            <div class="resp-col margin-bottom-15">
              <div class="textbox-with-4character textbox-with-btn">
                <input (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control" currencyMask [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }" (keyup)="buildTags($event,5)" maxlength="15" [(ngModel)]="searchCriteria.MinTerm" placeholder="- Min -" value="{{searchCriteria.MinTerm|number}}" />
                <span class="rightlabel">Years</span>
              </div>
            </div>
            <div class="resp-col">
              <div class="textbox-with-4character textbox-with-btn">
                <input (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control" currencyMask [options]="{ prefix: '', thousands: ',', decimal: '.', align: 'left', allowNegative: 'true', allowZero: 'true', precision: '0', nullable: 'true'  }" (keyup)="buildTags($event,5)" maxlength="15" [(ngModel)]="searchCriteria.MaxTerm" placeholder="- Max -" value="{{searchCriteria.MaxTerm|number}}" />
                <span class="rightlabel">Years</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div [class]="IsNull(searchCriteria?.States).length==0? 'form-group smalldiv' :'form-group smalldiv selected-div'">
    <div class="form-group width100">
      <div class="select-dropdown right-border multiselectdesign">
        <mat-form-field class="select-highlight">
          <mat-select #dropdownState placeholder="State" [(ngModel)]="searchCriteria.States"
                      (ngModelChange)="buildTags($event, 9);addState()" multiple class="custom-arrow-select" panelClass="dynamic-width">
            @if (searchCriteria?.States?.length > 1) {
            <mat-select-trigger>
              <span>{{ searchCriteria?.States?.length }} items selected</span>
            </mat-select-trigger>
            }
            <mat-option>
              <ngx-mat-select-search #searchKey
                                     [hideClearSearchButton]="true"
                                     placeholderLabel="Search by state"
                                     noEntriesFoundLabel="Nothing found..."
                                     [enableClearOnEscapePressed]="true"
                                     (click)="$event.stopPropagation()">
              </ngx-mat-select-search>
            </mat-option>

            @for (state of inputStates | arraySearch : 'name' : searchKey.value; track $index) {
            <mat-option (click)="$event.stopPropagation()" [value]="state.id" class="multi-dropdown-item">
              {{state.name}}
            </mat-option>
            }

          </mat-select>
        </mat-form-field>
      </div>
    </div>
  </div>
  <div [class]="(IsNull(searchCriteria.NOIFrom)+IsNull(searchCriteria.NOITo)+
               IsNull(searchCriteria.BuildingSizeFrom)+IsNull(searchCriteria.BuildingSizeTo)+
               IsNull(searchCriteria.YearBuiltFrom)+IsNull(searchCriteria.YearBuiltTo)+
               IsNull(searchCriteria.States)+IsNull(searchCriteria.LeaseStructures)+
               IsNull(searchCriteria.States)+IsNull(searchCriteria.CharacteristicsId)+
               IsNull(searchCriteria.CapRateFrom)+IsNull(searchCriteria.CapRateTo)+
               IsNull(searchCriteria.PropertyStatus)+IsNull(searchCriteria.SubCategories)+IsNull(searchCriteria.Brokerages)+IsNull(searchCriteria.OwnershipTypes)+
               IsNull(searchCriteria.RentFrom)+IsNull(searchCriteria.RentTo)+
               IsChecked(searchCriteria.IsExcludeSoldListing)+IsChecked(searchCriteria.IsOnlySoldListing)+IsChecked(searchCriteria.IsExcludeContractListing)+IsChecked(searchCriteria.IsOnlyFeaturedListing)
               )  =='' ?  'form-group advanced-filter-btn clearfix': 'form-group advanced-filter-btn clearfix selected-div'">
    <div class="btn-group select-dropdown clearfix right-border">
      <button type="button" class="btn btn-default btn-advanced btn-border" area-expanded="true" (click)="openModalAdvanceFilter(AdvacnceFilterPopUp,'commonmodal be-advanced-filter-modal')">
        <i aria-hidden="true" class="icon-be-filter icon-solar"></i>
      </button>
    </div>
  </div>
  <button class="searchbtn nosavesearchbtn" (click)="onPropertySearch();dropdown.hide()">Search</button>
  <!-- *ngIf="canShowsavedSearch"-->
  <a href="javascript:void(0);" tooltip="Save Search" (click)="openModal(template,'panlestyle')" class="btn-icon01" *ngIf="canShowsavedSearch"><i class="icon-save" aria-hidden="true"></i> Save</a>
  <a href="javascript:void(0);" class="btn-icon01" (click)="onResetClick();dropdown.hide()"><i class="icon-reset" aria-hidden="true" tooltip="Reset Search" placement="left"></i>Reset</a>
</div>
<div class="clearfix"></div>
<div  [ngClass]="{'search-tag-box' : filterTags?.length > 0,'no-tags':filterTags?.length <= 0 }">
  <span class="be-tag" *ngFor="let tag of filterTags;let i = index"> {{getFilterTagText(tag)}}<button type="button" class="tag-close" (click)="removeTag(tag.Id,1)"><span aria-hidden="true">&times;</span></button></span>
</div>


<ng-template #template class="pull-left">
  <div class="modal-header">
    <h4 class="modal-title pull-left">Save Search</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div class="form-group">
      <label class="form-label">Name</label>
      <input class="form-control" [(ngModel)]="saveSearchInputModel.SearchName" required type="text">
    </div>
    <div class="">
      <button class="btn btn-secondary" (click)="modalRef.hide();">Cancel</button>
      <button class="btn btn-success" (click)="saveSearch();">Save</button>
    </div>
  </div>

</ng-template>
<ng-template #AdvacnceFilterPopUp>
  <div class="modal-header no-border"><h4 class="modal-title pull-left">Advanced Filters</h4><button type="button" aria-label="Close" class="close pull-right" (click)="modalRefAdvanceFilter.hide();setOrginalSearchCriteria();"><span aria-hidden="true">x</span></button></div>
  <div class="modal-body">
    <div>
      <div>
        <div class="row">
          <div class="col-md-12">
            <div class="row">
              <div class="col-md-4">
                <div class="be-input-border">
                  <h3 class="bluelabel margin-bottom-15">Lease</h3>
                  <div class="form-full-border">
                    <label class="form-label">Lease Structure</label>
                    <div [class]="IsNull(searchCriteria.LeaseStructures)==''? 'select-dropdown  multiselectdesign select-check' : 'select-dropdown  multiselectdesign select-check activated'">
                      <div class="select-dropdown  multiselectdesign select-check">
                        <!-- <angular2-multiselect [data]="inputLeaseStructure" [(ngModel)]="searchCriteria.LeaseStructures" (ngModelChange)="buildTags($event,10);" [settings]="defaultLeaseStructureSettings"></angular2-multiselect> -->
                        <mat-form-field class="select-highlight">
                          <mat-select panelClass="dynamic-width" [(ngModel)]="searchCriteria.LeaseStructures"
                                      placeholder="- Select -" multiple>
                            @if (searchCriteria?.LeaseStructures?.length > 1) {
                            <mat-select-trigger>
                              <span>{{ searchCriteria?.LeaseStructures?.length }} items selected</span>
                            </mat-select-trigger>
                            }
                            @for (lease of inputLeaseStructure; track $index) {
                            <mat-option [value]="lease.id" (click)="$event.stopPropagation()" class="multi-dropdown-item">{{lease.name}}</mat-option>
                            }
                            <mat-option class="matoptionnodata" *ngIf="!inputLeaseStructure?.length" disabled>
                              Nothing found...
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="be-input-border">
                  <label class="form-label">NOI/Rent</label>
                  <div class="margin-bottom-20 row">
                    <div [class]="IsNull(searchCriteria.NOIFrom)==''? 'resp-col' : 'resp-col activated'">
                      <div class="textbox-with-btn-left">
                        <input inputmode="numeric" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                               mask="separator.10" thousandSeparator="," [(ngModel)]="searchCriteria.NOIFrom"
                               placeholder="Min ($)" maxlength="15"
                               (change)="validateFilters()">
                        <!--<span class="leftlabel">$</span>-->
                      </div>
                      <!--<span class="minusspan">-</span>-->
                    </div>
                    <div [class]="IsNull(searchCriteria.NOITo)==''? 'resp-col' : 'resp-col activated'">
                      <div class="textbox-with-btn-left">
                        <input inputmode="numeric" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                               mask="separator.10" thousandSeparator="," [(ngModel)]="searchCriteria.NOITo"
                               placeholder="Max ($)" maxlength="15"
                               (change)="validateFilters()">
                        <!--<span class="leftlabel">$</span>-->
                      </div>
                    </div>
                  </div>
                  <div *ngIf="(rentValidation!='')">
                    <p class="redtext">{{rentValidation}}</p>
                  </div>
                </div>
                <div class="be-input-border">
                  <label class="form-label">Tenants</label>
                  <mat-form-field class="select-highlight mobile-change-select matautocomplete">
                    <input matInput
                           placeholder="Search Tenants"
                           [matAutocomplete]="auto1"
                           [(ngModel)]="searchCriteria.TenantInput"
                           (input)="dataTenantServiceInput$.next($event.target.value);" />
                    <mat-autocomplete #auto1="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onTenantSelect($event.option.value)">
                      <ng-container *ngIf="dataTenantService$ | async as items">
                        <ng-container *ngIf="items.length > 0; else noTenantResults">
                          <mat-option class="split-location" *ngFor="let item of items; trackBy: trackByIndex"
                                      [value]="item">
                            <div class="split-container">
                              <span>{{ item.PropertyName }}</span>
                            </div>
                          </mat-option>
                        </ng-container>
                      </ng-container>
                      <ng-template #noTenantResults>
                        <mat-option disabled>
                          No data available
                        </mat-option>
                      </ng-template>
                    </mat-autocomplete>
                  </mat-form-field>
                  <!--<mat-form-field class="mat-no-border select-highlight mobile-change-select matautocomplete">
                    <input matInput
                           placeholder="Tenants"
                           [matAutocomplete]="auto1"
                           [(ngModel)]="searchCriteria.TenantAddressInput"
                           (input)="dataServiceInput$.next($event.target.value);" />

                    <mat-autocomplete #auto1="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onPropertySelect($event.option.value)">

                      <ng-container *ngIf="dataService$ | async as items">
                        <ng-container *ngIf="items.length > 0; else noResults">
                          <mat-option class="split-location" *ngFor="let item of items; trackBy: trackByIndex"
                                      [value]="item">
                            <div class="split-container">
                              <span>{{ item.PropertyName }}</span>
                              <span class="location-type">{{ item.Type }}</span>
                            </div>
                          </mat-option>
                        </ng-container>
                      </ng-container>
                      <ng-template #noResults>
                        <mat-option disabled>
                          No data available
                        </mat-option>
                      </ng-template>
                    </mat-autocomplete>
                  </mat-form-field>-->
                </div>
              </div>
              <div class="col-md-3">
                <h3 class="bluelabel margin-bottom-15">Rent Escalations</h3>
                <div class="be-input-border" style="min-height:74px;">
                  <label class="form-label">&nbsp;</label>
                  <div class="row form-radio">
                    <div class="col-md-4 col-sm-4 col-xs-6">
                      <label class="radio radio-inline">
                        <input name="radio" type="radio" #rdamount (change)="onRentEscalationChange(true)">
                        <i class="helper"></i>Amount
                      </label>
                    </div>
                    <div class="col-md-4 col-sm-4 col-xs-6">
                      <label class="radio radio-inline margin-bottom-10">
                        <!--<input name="radio" type="radio" (change)="onRentEscalationChange(false)">-->
                        <input name="radio" type="radio" #rdpercentage checked
                               (change)="onRentEscalationChange(false)" />
                        <i class="helper"></i>Percentage
                      </label>
                    </div>
                  </div>
                </div>
                <div class="be-input-border">
                  <label class="form-label">{{rdamount.checked ? 'Amount($)':'Percentage(%)'}}</label>
                  <div class="margin-bottom-20 row" *ngIf="rdamount.checked">
                    <div [class]="IsNull(searchCriteria.RentFrom)==''? 'resp-col' : 'resp-col activated'">
                      <div class="textbox-with-btn-left">
                        <input inputmode="numeric" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                               mask="separator.10" thousandSeparator="," [(ngModel)]="searchCriteria.RentFrom"
                               placeholder="Min ($)" maxlength="15"
                               (change)="validateFilters()">
                        <!--<span class="leftlabel">$</span>-->
                      </div>
                      <!--<span class="minusspan">-</span>-->
                    </div>
                    <div [class]="IsNull(searchCriteria.RentTo)==''? 'resp-col' : 'resp-col activated'">
                      <div class="textbox-with-btn-left">
                        <input inputmode="numeric" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                               mask="separator.10" thousandSeparator="," [(ngModel)]="searchCriteria.RentTo"
                               placeholder="Max ($)" maxlength="15"
                               (change)="validateFilters()">
                        <!--<span class="leftlabel">$</span>-->
                      </div>
                    </div>
                  </div>
                  <div class="margin-bottom-20 row" *ngIf="rdpercentage.checked">
                    <div [class]="IsNull(searchCriteria.RentFrom)==''? 'resp-col' : 'resp-col activated'">
                      <div class="textbox-with-btn textbox-with-2character">
                        <input inputmode="decimal" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                               [dropSpecialCharacters]="false" mask="999.99"
                               [(ngModel)]="searchCriteria.RentFrom" placeholder="Min (%)"
                               (change)="validateFilters()">
                        <!--<span class="rightlabel">%</span>-->
                      </div>
                      <!--<span class="minusspan">-</span>-->
                    </div>
                    <div [class]="IsNull(searchCriteria.RentTo)==''? 'resp-col' : 'resp-col activated'">
                      <div class="textbox-with-btn textbox-with-2character">
                        <input inputmode="decimal" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                               [dropSpecialCharacters]="false" mask="999.99"
                               [(ngModel)]="searchCriteria.RentTo" placeholder="Max (%)"
                               (change)="validateFilters()">
                        <!--<span class="rightlabel">%</span>-->
                      </div>
                    </div>
                  </div>
                  <div *ngIf="(rentescalationValidation!='')">
                    <p class="redtext">{{rentescalationValidation}}</p>
                  </div>
                </div>
                <div class="be-input-border">
                  <label class="form-label">Tenant Credit</label>
                  <mat-form-field class="select-highlight">
                    <mat-select panelClass="dynamic-width" [(ngModel)]="searchCriteria.Ratings"
                                placeholder="- Select -" multiple>

                      @if (searchCriteria?.Ratings?.length > 1) {
                      <mat-select-trigger>
                        <span>{{ searchCriteria?.Ratings.length }} items selected</span>
                      </mat-select-trigger>
                      }

                      @for (rate of inputRatings; track $index) {
                      <mat-option [value]="rate.id" (click)="$event.stopPropagation()" class="multi-dropdown-item">{{rate.name}}</mat-option>
                      }
                      <mat-option class="matoptionnodata" *ngIf="!inputRatings?.length" disabled>
                        Nothing found...
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-5">
                <h3 class="bluelabel margin-bottom-15">Building</h3>
                <div class="row">
                  <div class="col-md-7">
                    <div class="be-input-border">
                      <label class="form-label">Year Built</label>
                      <div class="margin-bottom-20 row">
                        <div [class]="IsNull(searchCriteria.YearBuiltFrom)==''? 'resp-col' : 'resp-col activated'">
                          <input (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                                 mask="9999" id="txtYearBuiltFrom" [(ngModel)]="searchCriteria.YearBuiltFrom"
                                 value="{{searchCriteria.YearBuiltFrom}}" placeholder="- From -"
                                 maxlength="4">
                          <span class="minusspan">-</span>
                        </div>
                        <div [class]="IsNull(searchCriteria.YearBuiltTo)==''? 'resp-col' : 'resp-col activated'">
                          <input (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                                 mask="9999" id="txtYearBuiltTo" [(ngModel)]="searchCriteria.YearBuiltTo"
                                 value="{{searchCriteria.YearBuiltTo}}" placeholder="- To -"
                                 maxlength="4">
                        </div>
                      </div>
                      <div *ngIf="(yearbuiltValidation!='')">
                        <p class="redtext">{{yearbuiltValidation}}</p>
                      </div>
                    </div>

                  </div>
                  <div class="col-md-5">
                    <label class="form-label">Characteristics</label>
                    <div [class]="IsNull(searchCriteria.CharacteristicsId)==''? 'select-dropdown  multiselectdesign select-check' : 'select-dropdown  multiselectdesign select-check activated'">
                      <div class="select-dropdown  multiselectdesign select-check">
                        <!-- <angular2-multiselect [data]="characteristicList" [(ngModel)]="searchCriteria.CharacteristicsId" (ngModelChange)="buildTags($event,19);" [settings]="defaultCharacteristicsSettings"></angular2-multiselect> -->
                        <mat-form-field class="select-highlight">
                          <mat-select panelClass="dynamic-width" [(ngModel)]="searchCriteria.CharacteristicsId"
                                      placeholder="- Select -" multiple>

                            @if(searchCriteria?.CharacteristicsId?.length > 1) {
                            <mat-select-trigger>
                              <span>{{ searchCriteria?.CharacteristicsId?.length }} items selected</span>
                            </mat-select-trigger>
                            }

                            @for (list of characteristicList; track $index) {
                            <mat-option [value]="list.id" (click)="$event.stopPropagation()" class="multi-dropdown-item">{{list.name}}</mat-option>
                            }
                            <mat-option class="matoptionnodata" *ngIf="!characteristicList?.length" disabled>
                              Nothing found...
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-7">
                    <label class="form-label">Building Size (Sq.Ft)</label>
                    <div class="margin-bottom-20 row">
                      <div [class]="IsNull(searchCriteria.BuildingSizeFrom)==''? 'resp-col' : 'resp-col activated'">
                        <div class="textbox-with-btn sfstyle be-input-border">
                          <input inputmode="decimal" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                                 [dropSpecialCharacters]="false" thousandSeparator="," mask="999999999999999999999.99"
                                 [(ngModel)]="searchCriteria.BuildingSizeFrom" placeholder="Min"
                                 (change)="validateFilters()">
                          <!--<span class="rightlabel">SF</span>-->
                        </div>
                        <!--<span class="minusspan">-</span>-->
                      </div>
                      <div [class]="IsNull(searchCriteria.BuildingSizeTo)==''? 'resp-col' : 'resp-col activated'">
                        <div class="textbox-with-btn sfstyle be-input-border">
                          <input inputmode="decimal" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                                 [dropSpecialCharacters]="false" thousandSeparator="," mask="999999999999999999999.99"
                                 [(ngModel)]="searchCriteria.BuildingSizeTo"
                                 placeholder="Max" (change)="validateFilters()">
                          <!--<span class="rightlabel">SF</span>-->
                        </div>
                      </div>
                    </div>
                    <div *ngIf="(buildsizeValidation!='')">
                      <p class="redtext">{{buildsizeValidation}}</p>
                    </div>
                  </div>

                </div>
              </div>

              <!----start-->
              <div class="col-md-12 margin-bottom-15 cf" *ngIf="tenantFilterTags && tenantFilterTags.length > 0">
                <div class="search-tag-box margin0">
                  <span class="be-tag" *ngFor="let tag of tenantFilterTags;let i = index">
                    {{getFilterTagText(tag)}}
                    <button type="button" class="tag-close"
                            (click)="removeTenantTag(tag)">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </span>
                </div>
              </div>
              <!----end-->

              <div class="col-md-12">
                <div class="border-sep cf" style="border-top: 1px solid #DCE0E4"></div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <h3 class="bluelabel margin-bottom-15 margin-top-15">Location</h3>
                <div class="row">
                  <div class="col-md-6" *ngIf="authService.Admin()||authService.Broker()||authService.SuperAdmin()">
                    <div class="be-input-border">
                      <label class="form-label">Address</label>
                      <mat-form-field class="select-highlight mobile-change-select matautocomplete">
                        <input matInput
                               placeholder="Search Address"
                               [matAutocomplete]="auto2"
                               [(ngModel)]="searchCriteria.TenantFullAdressInput"
                               (input)="AddressServiceInput$.next($event.target.value);" (ngModelChange)="onAddressInputChange($event)" />
                        <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onAddressSelect($event.option.value)">
                          <ng-container *ngIf="AddressService$ | async as items">
                            <ng-container *ngIf="items.length > 0; else noAddressResults">
                              <mat-option class="split-location" *ngFor="let item of items; trackBy: trackByIndex"
                                          [value]="item">
                                <div class="split-container">
                                  <span>{{ item.PropertyName }}</span>
                                </div>
                              </mat-option>
                            </ng-container>
                          </ng-container>

                          <ng-template #noAddressResults>
                            <mat-option disabled>
                              No data available
                            </mat-option>
                          </ng-template>
                        </mat-autocomplete>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="be-input-border">
                      <label class="form-label">State</label>
                      <div class="form-group">
                        <div [class]="IsNull(searchCriteria.AdvanceFilterStates)==''? 'select-dropdown  multiselectdesign select-check' : 'select-dropdown  multiselectdesign select-check activated'">
                          <mat-form-field class="select-highlight">
                            <mat-select #dropdownState placeholder="- Select -" [(ngModel)]="searchCriteria.AdvanceFilterStates"
                                        (ngModelChange)="dropdownStateClose($event); bindCity(searchCriteria?.AdvanceFilterStates)" multiple panelClass="dynamic-width">
                              @if (searchCriteria?.AdvanceFilterStates?.length > 1) {
                              <mat-select-trigger>
                                <span>{{ searchCriteria?.AdvanceFilterStates?.length }} items selected</span>
                              </mat-select-trigger>
                              }
                              <mat-option>
                                <ngx-mat-select-search #searchKey
                                                       [hideClearSearchButton]="true"
                                                       placeholderLabel="Search by state"
                                                       noEntriesFoundLabel="Nothing found..."
                                                       [enableClearOnEscapePressed]="true"
                                                       (click)="$event.stopPropagation()">
                                </ngx-mat-select-search>
                              </mat-option>

                              @for (state of inputStates | arraySearch : 'name' : searchKey.value; track $index) {
                              <mat-option (click)="$event.stopPropagation()" [value]="state.id" class="multi-dropdown-item">
                                {{state.name}}
                              </mat-option>
                              }

                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="be-input-border">
                      <label class="form-label">City</label>
                      <div class="form-group">
                        <div [class]="IsNull(searchCriteria.CityId)==''? 'select-dropdown  multiselectdesign select-check' : 'select-dropdown  multiselectdesign select-check activated'">
                          <label class="select">
                            <select [(ngModel)]="searchCriteria.CityId" class="form-control" [ngClass]="{'placeholder': !searchCriteria.CityId}" (click)="checkState()">
                              <option [ngValue]="null">- Select -</option>
                              <option *ngFor="let city of citiesList" [(ngValue)]="city.Id">{{city.Name}}</option>
                            </select>
                            <i></i>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6" *ngIf="authService.Admin()||authService.Broker()||authService.SuperAdmin()">
                    <label class="form-label">Property Id</label>
                    <div class="form-group be-input-border">
                      <div>
                        <div>
                          <input (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control"
                                 id="txtPropertySequenceId" [(ngModel)]="searchCriteria.PropertySequenceId"
                                 value="{{searchCriteria.PropertySequenceId}}"
                                 placeholder="Property Id" maxlength="40">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <h3 class="bluelabel margin-bottom-15 margin-top-15">Listing Attributes</h3>
                <div class="row">
                  <div class="col-md-7">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="be-input-border">
                          <label class="form-label">Property Status</label>
                          <div class="form-group margin-bottom-20">
                            <div [class]="IsNull(searchCriteria.PropertyStatus)==''? 'select-dropdown r multiselectdesign select-check' : 'select-dropdown r multiselectdesign select-check activated'">
                              <mat-form-field class="select-highlight">
                                <mat-select panelClass="dynamic-width" [(ngModel)]="searchCriteria.PropertyStatus"
                                            placeholder="- Select -" multiple>
                                  @if(searchCriteria?.PropertyStatus?.length > 1) {
                                  <mat-select-trigger>
                                    <span>{{ searchCriteria?.PropertyStatus?.length }} items selected</span>
                                  </mat-select-trigger>
                                  }

                                  @for (property of inputPropertyStatus; track $index) {
                                  <mat-option [value]="property.id"
                                              (click)="$event.stopPropagation()" class="multi-dropdown-item">{{property.name}}</mat-option>
                                  }
                                  <mat-option class="matoptionnodata" *ngIf="!inputPropertyStatus?.length" disabled>
                                    Nothing found...
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                        <div class="be-input-border">
                          <label class="form-label">Brokerage</label>
                          <div class="form-group margin-bottom-20">
                            <div [class]="IsNull(searchCriteria.Brokerages)==''? 'select-dropdown r multiselectdesign select-check' : 'select-dropdown r multiselectdesign select-check activated'">
                              <mat-form-field class="select-highlight">
                                <mat-select placeholder="- Select -"
                                            [(ngModel)]="searchCriteria.Brokerages"
                                            (ngModelChange)="dropdownBrokarageChange($event);"
                                            multiple panelClass="dynamic-width">
                                  @if (searchCriteria.Brokerages?.length > 1) {
                                  <mat-select-trigger>
                                    <span>{{ searchCriteria.Brokerages?.length }} items selected</span>
                                  </mat-select-trigger>
                                  }
                                  @for (brokerage of brokerageList; track brokerage) {
                                  <mat-option [value]="brokerage.id" class="multi-dropdown-item">{{brokerage.name}}</mat-option>
                                  }
                                  @if (brokerageList.length === 0) {
                                  <mat-option class="matoptionnodata" disabled>Nothing found...</mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="be-input-border">
                          <label class="form-label">Ownership Structure</label>
                          <div class="form-group margin-bottom-20">
                            <div [class]="IsNull(searchCriteria.OwnershipTypes)==''? 'select-dropdown  multiselectdesign select-check' : 'select-dropdown  multiselectdesign select-check activated'">
                              <mat-form-field class="select-highlight">
                                <mat-select panelClass="dynamic-width" [(ngModel)]="searchCriteria.OwnershipTypes"
                                            placeholder="- Select -" multiple>
                                  @if(searchCriteria?.OwnershipTypes?.length > 1) {
                                  <mat-select-trigger>
                                    <span>{{ searchCriteria?.OwnershipTypes?.length }} items selected</span>
                                  </mat-select-trigger>
                                  }
                                  @for (owner of inputOwnershipStructure; track $index) {
                                  <mat-option [value]="owner.id" (click)="$event.stopPropagation()" class="multi-dropdown-item">{{owner.name}}</mat-option>
                                  }
                                  <mat-option class="matoptionnodata" *ngIf="!inputOwnershipStructure?.length" disabled>
                                    Nothing found...
                                  </mat-option>
                                </mat-select>
                              </mat-form-field>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-5">
                    <label class="form-label"></label>
                    <div class="search-check-box d-flex margin-top-40">
                      <label class="custom-checkbox">
                        <input type="checkbox"
                               [(ngModel)]="searchCriteria.IsPortfolio" />
                        <i class="helper"></i>Show Only Portfolios
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="clearfix"></div>
          <div class="d-flex">
            <div class="d-inline-flex ml-auto align-items-center" style="padding-right:15px">
              <button class="btn-link margin-right-15" (click)="onResetAdvanceFilterClick();onApplyFilterClick(false);">Clear All</button>
              <button class="btn btn-success btn-lg" (click)="onApplyFilterClick(true)">Apply</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<!--<div class="btn-group select-dropdown clearfix right-border" dropdown #dropdown="bs-dropdown" [autoClose]="false">
  <button dropdownToggle type="button" class="btn btn-default dropdown-toggle btn-advanced" area-expanded="true">
    Advanced Filters <span class="caret"></span>
  </button>
  <div *dropdownMenu class="dropdown-menu dropdown-div mega-dropdown dropdown-menu-right" (click)="$event.stopPropagation()">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-4 col-sm-4 col-xs-12">
              <label class="form-label">NOI/Rent</label>
              <div class="margin-bottom-20 row">
                <div [class]="IsNull(searchCriteria.NOIFrom)==''? 'resp-col' : 'resp-col activated'">
                  <div class="textbox-with-btn-left">
                    <input inputmode="numeric" maxlength="15" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control" mask="separator.10" thousandSeparator="," (keyup)="buildTags($event,6)" [(ngModel)]="searchCriteria.NOIFrom" placeholder="- Min -" (change)="validateFilters()">
                    <span class="leftlabel">$</span>
                  </div>
                  <span class="minusspan">-</span>
                </div>
                <div [class]="IsNull(searchCriteria.NOITo)==''? 'resp-col' : 'resp-col activated'">
                  <div class="textbox-with-btn-left">
                    <input inputmode="numeric" maxlength="15" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control" mask="separator.10" thousandSeparator="," (keyup)="buildTags($event,6)" [(ngModel)]="searchCriteria.NOITo" placeholder="- Max -" (change)="validateFilters()">
                    <span class="leftlabel">$</span>
                  </div>
                </div>
              </div>
              <div *ngIf="(rentValidation!='')">
                <p class="redtext">{{rentValidation}}</p>
              </div>
            </div>
            <div class="col-md-4 col-sm-4 col-xs-12">
              <label class="form-label">Building Size (SF)</label>
              <div class="margin-bottom-20 row">
                <div [class]="IsNull(searchCriteria.BuildingSizeFrom)==''? 'resp-col' : 'resp-col activated'">
                  <input inputmode="decimal" thousandSeparator="," [dropSpecialCharacters]="false" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control" mask="999999999999999999999.99" (keyup)="buildTags($event,7)" [(ngModel)]="searchCriteria.BuildingSizeFrom" placeholder="- Min -" (change)="validateFilters()">
                  <span class="minusspan">-</span>
                </div>
                <div [class]="IsNull(searchCriteria.BuildingSizeTo)==''? 'resp-col' : 'resp-col activated'">
                  <input inputmode="decimal" thousandSeparator="," [dropSpecialCharacters]="false" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control" mask="999999999999999999999.99" (keyup)="buildTags($event,7)" [(ngModel)]="searchCriteria.BuildingSizeTo" placeholder="- Max -" (change)="validateFilters()">
                </div>
              </div>
              <div *ngIf="(buildsizeValidation!='')">
                <p class="redtext">{{buildsizeValidation}}</p>
              </div>
            </div>
            <div class="col-md-4 col-sm-4 col-xs-12">
              <label class="form-label">Year Built</label>
              <div class="margin-bottom-20 row">
                <div [class]="IsNull(searchCriteria.YearBuiltFrom)==''? 'resp-col' : 'resp-col activated'">
                  <input (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control" mask="9999" [(ngModel)]="searchCriteria.YearBuiltFrom" value="{{searchCriteria.YearBuiltFrom}}" (keyup)="buildTags($event,8)" placeholder="- From -" maxlength="4" (change)="validateFilters()">
                  <span class="minusspan">-</span>
                </div>
                <div [class]="IsNull(searchCriteria.YearBuiltTo)==''? 'resp-col' : 'resp-col activated'">
                  <input (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control" mask="9999" [(ngModel)]="searchCriteria.YearBuiltTo" value="{{searchCriteria.YearBuiltTo}}" (keyup)="buildTags($event,8)" placeholder="- To -" maxlength="4" (change)="validateFilters()">
                </div>
              </div>
              <div *ngIf="(yearbuiltValidation!='')">
                <p class="redtext">{{yearbuiltValidation}}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-3 col-sm-3 col-xs-12">
              <label class="form-label">Property Id</label>
              <div class="form-group margin-bottom-20">
                <div>
                  <div>
                    <input (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control" id="txtPropertySequenceId" [(ngModel)]="searchCriteria.PropertySequenceId" value="{{searchCriteria.PropertySequenceId}}" (keyup)="buildTags($event,22)" placeholder="Property Id" maxlength="40">
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-sm-3 col-xs-12">
              <label class="form-label">State</label>
              <div class="form-group margin-bottom-20">
                <div [class]="IsNull(searchCriteria.States)==''? 'select-dropdown  multiselectdesign select-check' : 'select-dropdown  multiselectdesign select-check activated'">
                  <mat-form-field class="select-highlight">
                    <mat-select placeholder="- Select -"
                                [(ngModel)]="searchCriteria.States"
                                #dropdownState
                                (ngModelChange)="dropdownStateClose($event);buildTags($event,9);"
                                multiple>
                      @if (searchCriteria.States?.length > 1) {
                      <mat-select-trigger>
                        <span>{{ searchCriteria.States?.length }} items selected</span>
                      </mat-select-trigger>
                      }
                      <mat-option (click)="$event.stopPropagation()">
                        <ngx-mat-select-search #searchKey
                                               [disableInitialFocus]="true"
                                               [hideClearSearchButton]="true"
                                               [clearSearchInput]="false"
                                               placeholderLabel="Search states..."
                                               noEntriesFoundLabel="Nothing found...">
                        </ngx-mat-select-search>
                      </mat-option>
                      @for (state of inputStates | arraySearch : 'name' : searchKey.value; track state) {
                      <mat-option [value]="state.id" class="multi-dropdown-item">{{state.name}}</mat-option>
                      }
                      @if (inputStates.length === 0) {
                      <mat-option class="matoptionnodata" disabled>Nothing found...</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-sm-3 col-xs-12">
              <label class="form-label">Lease Structure</label>
              <div [class]="IsNull(searchCriteria.LeaseStructures)==''? 'select-dropdown  multiselectdesign select-check' : 'select-dropdown  multiselectdesign select-check activated'">
                <div class="select-dropdown multiselectdesign select-check">
                  <mat-form-field class="select-highlight">
                    <mat-select placeholder="- Select -"
                                [(ngModel)]="searchCriteria.LeaseStructures"
                                (ngModelChange)="buildTags($event,10);"
                                multiple>
                      @if (searchCriteria.LeaseStructures?.length > 1) {
                      <mat-select-trigger>
                        <span>{{ searchCriteria.LeaseStructures?.length }} items selected</span>
                      </mat-select-trigger>
                      }
                      @for (lease of inputLeaseStructure; track lease) {
                      <mat-option [value]="lease.id" class="multi-dropdown-item">{{lease.name}}</mat-option>
                      }
                      @if (inputLeaseStructure.length === 0) {
                      <mat-option class="matoptionnodata" disabled>Nothing found...</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-md-3 col-sm-3 col-xs-12">
              <label class="form-label">Rating</label>
              <div [class]="IsNull(searchCriteria.Ratings).length==0  ? 'select-dropdown  multiselectdesign select-check' :'select-dropdown  multiselectdesign select-check activated'">
                <div class="select-dropdown multiselectdesign select-check">
                  <mat-form-field class="select-highlight">
                    <mat-select placeholder="Rating"
                                [(ngModel)]="searchCriteria.Ratings"
                                (ngModelChange)="buildTags($event,4)"
                                multiple>
                      @if (searchCriteria.Ratings?.length > 1) {
                      <mat-select-trigger>
                        <span>{{ searchCriteria.Ratings?.length }} items selected</span>
                      </mat-select-trigger>
                      }
                      @for (rating of inputRatings; track rating) {
                      <mat-option [value]="rating.id" class="multi-dropdown-item">{{rating.name}}</mat-option>
                      }
                      @if (inputRatings.length === 0) {
                      <mat-option class="matoptionnodata" disabled>Nothing found...</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-4 col-sm-4 col-xs-12">
              <label class="form-label">Property Status</label>
              <div class="form-group margin-bottom-20">
                <div [class]="IsNull(searchCriteria.PropertyStatus)==''? 'select-dropdown r multiselectdesign select-check' : 'select-dropdown r multiselectdesign select-check activated'">
                  <mat-form-field class="select-highlight">
                    <mat-select placeholder="- Select -"
                                [(ngModel)]="searchCriteria.PropertyStatus"
                                (ngModelChange)="buildTags($event,12);"
                                multiple>
                      @if (searchCriteria.PropertyStatus?.length > 1) {
                      <mat-select-trigger>
                        <span>{{ searchCriteria.PropertyStatus?.length }} items selected</span>
                      </mat-select-trigger>
                      }
                      @for (status of inputPropertyStatus; track status) {
                      <mat-option [value]="status.id" class="multi-dropdown-item">{{status.name}}</mat-option>
                      }
                      @if (inputPropertyStatus.length === 0) {
                      <mat-option class="matoptionnodata" disabled>Nothing found...</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-4 col-xs-12">
              <label class="form-label">Subcategory</label>
              <div class="form-group margin-bottom-20">
                <div [class]="IsNull(searchCriteria.SubCategories)==''? 'select-dropdown  multiselectdesign select-check' : 'select-dropdown  multiselectdesign select-check activated'">
                  <mat-form-field class="select-highlight">
                    <mat-select placeholder="- Select -"
                                [(ngModel)]="searchCriteria.SubCategories"
                                (ngModelChange)="buildTags($event,13);"
                                multiple>
                      @if (searchCriteria.SubCategories?.length > 1) {
                      <mat-select-trigger>
                        <span>{{ searchCriteria.SubCategories?.length }} items selected</span>
                      </mat-select-trigger>
                      }
                      @for (subcategory of inputSubCategory; track subcategory) {
                      <mat-option [value]="subcategory.id" class="multi-dropdown-item">{{subcategory.name}}</mat-option>
                      }
                      @if (inputSubCategory.length === 0) {
                      <mat-option class="matoptionnodata" disabled>Nothing found...</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-4 col-xs-12">
              <label class="form-label">Ownership Structure</label>
              <div class="form-group margin-bottom-20">
                <div [class]="IsNull(searchCriteria.OwnershipTypes)==''? 'select-dropdown  multiselectdesign select-check' : 'select-dropdown  multiselectdesign select-check activated'">
                  <mat-form-field class="select-highlight">
                    <mat-select placeholder="- Select -"
                                [(ngModel)]="searchCriteria.OwnershipTypes"
                                (ngModelChange)="buildTags($event,14);"
                                multiple>
                      @if (searchCriteria.OwnershipTypes?.length > 1) {
                      <mat-select-trigger>
                        <span>{{ searchCriteria.OwnershipTypes?.length }} items selected</span>
                      </mat-select-trigger>
                      }
                      @for (ownership of inputOwnershipStructure; track ownership) {
                      <mat-option [value]="ownership.id" class="multi-dropdown-item">{{ownership.name}}</mat-option>
                      }
                      @if (inputOwnershipStructure.length === 0) {
                      <mat-option class="matoptionnodata" disabled>Nothing found...</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-4 col-sm-4 col-xs-12">
              <label class="form-label">Rent Escalation</label>

              <div class="row form-radio">
                <div class="col-md-6 col-sm-6 col-xs-6">
                  <label class="radio radio-inline">
                    <input name="radio" type="radio" #rdamount (change)="onRentEscalationChange(true)">
                    <i class="helper"></i>Amount
                  </label>
                </div>
                <div class="col-md-6 col-sm-6 col-xs-6">
                  <label class="radio radio-inline margin-bottom-10">-->
<!--<input name="radio" type="radio" (change)="onRentEscalationChange(false)">-->
<!--<input name="radio" type="radio" #rdpercentage checked (change)="onRentEscalationChange(false)" />
        <i class="helper"></i>Percentage
      </label>
    </div>
  </div>
  <div class="margin-bottom-20 row" *ngIf="rdamount.checked">
    <div [class]="IsNull(searchCriteria.RentFrom)==''? 'resp-col' : 'resp-col activated'">
      <div class="textbox-with-btn-left">
        <input inputmode="numeric" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control" mask="separator.10" thousandSeparator="," (keyup)="buildTags($event,15);" [(ngModel)]="searchCriteria.RentFrom" placeholder="- Min -" maxlength="15" (change)="validateFilters()">
        <span class="leftlabel">$</span>
      </div>
      <span class="minusspan">-</span>
    </div>
    <div [class]="IsNull(searchCriteria.RentTo)==''? 'resp-col' : 'resp-col activated'">
      <div class="textbox-with-btn-left">
        <input inputmode="numeric" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control" mask="separator.10" thousandSeparator="," (keyup)="buildTags($event,15);" [(ngModel)]="searchCriteria.RentTo" placeholder="- Max -" maxlength="15" (change)="validateFilters()">
        <span class="leftlabel">$</span>
      </div>
    </div>
  </div>
  <div class="margin-bottom-20 row" *ngIf="rdpercentage.checked">
    <div [class]="IsNull(searchCriteria.RentFrom)==''? 'resp-col' : 'resp-col activated'">
      <div class="textbox-with-btn textbox-with-2character">
        <input inputmode="decimal" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control" [dropSpecialCharacters]="false" mask="999.99" (keyup)="buildTags($event,15);" [(ngModel)]="searchCriteria.RentFrom" placeholder="- Min -" (change)="validateFilters()">
        <span class="rightlabel">%</span>
      </div>
      <span class="minusspan">-</span>
    </div>
    <div [class]="IsNull(searchCriteria.RentTo)==''? 'resp-col' : 'resp-col activated'">
      <div class="textbox-with-btn textbox-with-2character">
        <input inputmode="decimal" (keydown)="onInputKeyPress($event)" type="text" class="search-field-input form-control" [dropSpecialCharacters]="false" mask="999.99" (keyup)="buildTags($event,15);" [(ngModel)]="searchCriteria.RentTo" placeholder="- Max -" (change)="validateFilters()">
        <span class="rightlabel">%</span>
      </div>
    </div>
  </div>
  <div *ngIf="(rentescalationValidation!='')">
    <p class="redtext">{{rentescalationValidation}}</p>
  </div>
</div>
<div class="col-md-4 col-sm-4 col-xs-12">
  <label class="form-label">Brokerage</label>
  <div class="form-group margin-bottom-20">
    <div [class]="IsNull(searchCriteria.Brokerages)==''? 'select-dropdown  multiselectdesign select-check' : 'select-dropdown  multiselectdesign select-check activated'">
      <mat-form-field class="select-highlight">
        <mat-select placeholder="- Select -"
                    [(ngModel)]="searchCriteria.Brokerages"
                    (ngModelChange)="dropdownBrokarageChange($event);buildTags($event,18);"
                    multiple>
          @if (searchCriteria.Brokerages?.length > 1) {
          <mat-select-trigger>
            <span>{{ searchCriteria.Brokerages?.length }} items selected</span>
          </mat-select-trigger>
          }
          @for (brokerage of brokerageList; track brokerage) {
          <mat-option [value]="brokerage.id" class="multi-dropdown-item">{{brokerage.name}}</mat-option>
          }
          @if (brokerageList.length === 0) {
          <mat-option class="matoptionnodata" disabled>Nothing found...</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>
<div class="col-md-4 col-sm-4 col-xs-12">
  <label class="form-label">Property Characteristics</label>
  <div [class]="IsNull(searchCriteria.CharacteristicsId)==''? 'select-dropdown  multiselectdesign select-check' : 'select-dropdown  multiselectdesign select-check activated'">
    <div class="select-dropdown multiselectdesign select-check">
      <mat-form-field class="select-highlight">
        <mat-select placeholder="Property Characteristics"
                    [(ngModel)]="searchCriteria.CharacteristicsId"
                    (ngModelChange)="buildTags($event,19);"
                    multiple>
          @if (searchCriteria.CharacteristicsId?.length > 1) {
          <mat-select-trigger>
            <span>{{ searchCriteria.CharacteristicsId?.length }} items selected</span>
          </mat-select-trigger>
          }
          @for (characteristic of characteristicList; track characteristic) {
          <mat-option [value]="characteristic.id" class="multi-dropdown-item">{{characteristic.name}}</mat-option>
          }
          @if (characteristicList.length === 0) {
          <mat-option class="matoptionnodata" disabled>Nothing found...</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
</div>-->
<!--<div class="col-md-4 col-sm-4 col-xs-12">
    <div class="margin-bottom-20">
        <label class="custom-checkbox" [ngStyle]="{'opacity':searchCriteria.IsExcludeSoldListing ? '0.5' : '1' }">
            <input type="checkbox" [(ngModel)]="searchCriteria.IsOnlySoldListing" [disabled]="searchCriteria.IsExcludeSoldListing" />
            <i class="helper"></i>Show only sold listings
        </label>
    </div>
</div>

<div class="col-md-4 col-sm-4 col-xs-12">
    <div class="margin-bottom-20">
        <label class="custom-checkbox ">
            <input type="checkbox" [(ngModel)]="searchCriteria.IsOnlyFeaturedListing" />
            <i class="helper"></i>Show only featured listing
        </label>
    </div>
</div>-->
<!--<div class="col-md-4 col-sm-4 col-xs-12">
    <div class="margin-bottom-20">
        <label class="custom-checkbox ">
            <input type="checkbox" [(ngModel)]="searchCriteria.IsOnlyFeaturedListing" />
            <i class="helper"></i>Show source updated properties
        </label>
    </div>
</div>-->
<!--</div>
        </div>
        <div class="col-md-12">
          <div class="row">
            <div class="col-md-4 col-sm-4 col-xs-12">
              <label class="form-label">Date On Market</label>
              <div class="margin-bottom-20 row">
                <div [class]="IsNull(searchCriteria.DOMStartDate)==''? 'resp-col' : 'resp-col activated'">
                  <div class="textbox-date">
                    <input bsDatepicker class="form-control" placeholder="From" placement="auto" style="color:black !important" [(ngModel)]="searchCriteria.DOMStartDate" (ngModelChange)="buildTags($event,23);" type="text">
                    <i class="icofont icofont-ui-calendar icon"></i>
                  </div>
                  <span class="minusspan">-</span>
                </div>
                <div [class]="IsNull(searchCriteria.DOMEndDate)==''? 'resp-col' : 'resp-col activated'">
                  <div class="textbox-date">
                    <input bsDatepicker class="form-control" placement="auto" [(ngModel)]="searchCriteria.DOMEndDate" (ngModelChange)="buildTags($event,23);" style="color:black !important" placeholder="To" type="text">
                    <i class="icofont icofont-ui-calendar icon"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="margin-bottom-20">
                <label class="custom-checkbox" [ngStyle]="{'opacity':searchCriteria.IsOnlySoldListing ? '0.5' : '1' }">
                  <input type="checkbox" [(ngModel)]="searchCriteria.IsExcludeSoldListing" (change)="buildTags($event,16);" [disabled]="searchCriteria.IsOnlySoldListing" />
                  <i class="helper"></i>Exclude sold listings
                </label>
              </div>
            </div>
            <div class="col-md-4 col-sm-4 col-xs-12">
              <div class="margin-bottom-20">
                <label class="custom-checkbox ">
                  <input type="checkbox" [(ngModel)]="searchCriteria.IsExcludeContractListing" (change)="buildTags($event,17);" />
                  <i class="helper"></i>Exclude listings under contract
                </label>
              </div>
            </div>
            <div class="col-md-4 col-sm-4 col-xs-12" *ngIf="this.parentPage != 1">
              <div class="margin-bottom-20">
                <label class="custom-checkbox ">
                  <input type="checkbox" [(ngModel)]="searchCriteria.IsPortfolio" (change)="buildTags($event,20);" />
                  <i class="helper"></i>Show Only Portfolios
                </label>
              </div>
            </div>
            <div class="col-md-4 col-sm-4 col-xs-12" *ngIf="IsAdmin">
              <div class="margin-bottom-20">
                <label class="custom-checkbox ">
                  <input type="checkbox" [(ngModel)]="searchCriteria.PortfolioSaleOnly" (change)="buildTags($event,21);" />
                  <i class="helper"></i>Portfolio Sale Only
                </label>
              </div>
            </div>
          </div>
        </div>
        <div class="clearfix col-md-12">
          <button class="underline-link" (click)="onResetFilterClick();">Reset</button>
        </div>
      </div>
    </div>
  </div>
</div>-->
